/* This function slides down and up the content of a "Coverage" element */

function toggleCoverage(e) {
	const self = e.delegateTarget,
		arrow = $(self).find('.arrow img'),
		content = $(self).find('.content');

	if (arrow.hasClass('rotated')) {
		content.slideUp(400);
		arrow.css({
			'transform': 'rotate(0deg)',
			'transition': 'transform .5s',
			'transition-timing-function': 'ease-in'
		});
		arrow.removeClass('rotated');
	} else {
		content.slideDown(400);
		arrow.css({
			'transform': 'rotate(180deg)',
			'transition': 'transform .5s',
			'transition-timing-function': 'ease-in'
		});
		arrow.addClass('rotated');
	}
};

$('.toggle-coverage').click((e) => toggleCoverage(e));
